export default __webpack_public_path__ + "static/media/triangle-up.98cfd163.svg";